import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
import { WEBSITE_VIEW_TYPES, BOOKING_STATUSES, BOOKING_PAYMENT_STATUSES } from 'src/consumer/constants'

export const bookedPageViewTypes = {
  booked_sessions: 'booked-sessions',
  new: 'new',
}

export const pageViewUrlTypesValidator = {
  [bookedPageViewTypes?.booked_sessions]: bookedPageViewTypes?.booked_sessions,
  [bookedPageViewTypes?.new]: bookedPageViewTypes?.new,
}

export const prefixedLinkForNavigates = {
  [WEBSITE_VIEW_TYPES.default]: `/my-live-sessions`,
  [WEBSITE_VIEW_TYPES.webview]: `/webview/my-live-sessions`,
}

/**
 * Checks if a booked event is blocked (payment pending - slot held but not confirmed)
 * Blocked sessions should not allow anyone to join
 * @param {Object} item - The booked event data
 * @returns {boolean} - True if the session is blocked
 */
export const isSessionBlocked = (item) => {
  return (
    item?.status === BOOKING_STATUSES.BOOKING_INITIATED &&
    item?.paymentStatus === BOOKING_PAYMENT_STATUSES.PENDING
  )
}

export const checkIfEventUpcoming = (item, currentTime) =>
  dayjs?.utc(item?.endTime)?.local()?.isAfter(dayjs?.(currentTime))

/**
 * Checks if an event can be joined
 * Returns false if session is blocked (payment pending) - no user can join a blocked session
 * @param {Object} item - The booked event data
 * @param {string} currentTime - Current time string
 * @returns {boolean} - True if the event can be joined
 */
export const canEventBeJoined = (item, currentTime) => {
  // Blocked sessions cannot be joined by anyone
  if (isSessionBlocked(item)) {
    return false
  }
  // Check if within 30 minutes of start time
  return dayjs?.utc(item?.startTime)?.diff(dayjs?.(currentTime), 'seconds') < 1800
}

export const checkIfAllowedToJoinAllDay = (item) => {
  // Blocked sessions cannot be joined by anyone
  if (isSessionBlocked(item)) {
    return false
  }
  const eventStartDayjs = dayjs(item?.startTime)
  if (
    (item?.meetingSrc === 'offline' || item?.clinicId) &&
    eventStartDayjs.isSame(dayjs(), 'day') &&
    !item?.markedCompleted
  ) {
    return true
  }
  return false
}

export function getMyRoleForThisEvent(bookedEventData, userProfileData) {
  let toReturn
  if (bookedEventData?.userId === userProfileData?.userId) {
    toReturn = 'user'
  } else if (bookedEventData?.mentorId === userProfileData?.teacher?.id) {
    toReturn = 'mentor'
  } else if (bookedEventData?.panelIds?.includes(userProfileData?.teacher?.id)) {
    toReturn = 'panelist'
  }
  return toReturn
}

export function deviceIdToSinkId(deviceId) {
  if (deviceId === 'default') return ''
  if (deviceId === 'silent') return { type: 'none' }
  return deviceId
}
